// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.super-pickem-user-dash-header {
  width: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  padding: 16px 5px;
  align-items: center;
}
@media (max-width: 925px) {
  .super-pickem-user-dash-header {
    padding: 5px;
  }
}

.super-pickem-user-dash-trophy {
  width: 48px;
}
@media (max-width: 925px) {
  .super-pickem-user-dash-trophy {
    width: 20px;
    padding-right: 5px;
  }
}

.bracket-box-header {
  width: 100%;
  background: #F2F2F2;
  height: 215px;
  border-top: 8px solid #FFC60A;
  border-bottom: 8px solid #FFC60A;
}
@media (max-width: 925px) {
  .bracket-box-header {
    height: 87px;
    border-top: 4px solid #FFC60A;
    border-bottom: 4px solid #FFC60A;
  }
}

.super-pickem-user-dash-username {
  font-weight: 800 !important;
  margin-left: 8px !important;
}
@media (max-width: 925px) {
  .super-pickem-user-dash-username {
    color: #002129;
    font-family: Inter;
    font-size: 16px !important;
    font-style: normal;
    line-height: normal;
    font-weight: 800 !important;
    margin-left: 0px;
  }
}

.super-pickem-user-dash-headings {
  color: #4A4A4A;
  text-align: center;
  font-family: Inter;
  font-style: normal;
  font-weight: 800;
  line-height: normal;
  text-decoration-line: underline;
  font-size: 24px !important;
}
@media (max-width: 925px) {
  .super-pickem-user-dash-headings {
    font-size: 10px !important;
    font-weight: 800 !important;
  }
}

.super-pickem-user-dash-values {
  color: #4A4A4A;
  text-align: center;
  font-family: Inter;
  font-style: normal;
  font-weight: 800;
  line-height: normal;
  font-size: 32px !important;
}
@media (max-width: 925px) {
  .super-pickem-user-dash-values {
    font-size: 12px !important;
    font-weight: 800;
  }
}

.super-pickem-user-dash-double-line-values {
  color: #4A4A4A;
  text-align: center;
  font-family: Inter;
  font-style: normal;
  font-weight: 800;
  line-height: normal;
  font-size: 24px !important;
}
@media (max-width: 925px) {
  .super-pickem-user-dash-double-line-values {
    font-size: 12px !important;
    font-weight: 800;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/SuperPickem/UserDash/SuperPickemUserDash.scss"],"names":[],"mappings":"AAKA;EACE,WAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,iBAAA;EACA,mBAAA;AAJF;AAKE;EAPF;IAQI,YAAA;EAFF;AACF;;AAKA;EACE,WAAA;AAFF;AAGE;EAFF;IAGI,WAAA;IACA,kBAAA;EAAF;AACF;;AAGA;EACE,WAAA;EACA,mBAAA;EACA,aAAA;EACA,6BAAA;EACA,gCAAA;AAAF;AACE;EANF;IAOI,YAAA;IACA,6BAAA;IACA,gCAAA;EAEF;AACF;;AACA;EACE,2BAAA;EACA,2BAAA;AAEF;AADE;EAHF;IAII,cAAA;IACA,kBAAA;IACA,0BAAA;IACA,kBAAA;IACA,mBAAA;IACA,2BAAA;IACA,gBAAA;EAIF;AACF;;AADA;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,+BAAA;EACA,0BAAA;AAIF;AAFE;EAVF;IAWI,0BAAA;IACA,2BAAA;EAKF;AACF;;AADA;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,0BAAA;AAIF;AAFE;EATF;IAUI,0BAAA;IACA,gBAAA;EAKF;AACF;;AADA;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,0BAAA;AAIF;AAFE;EATF;IAUI,0BAAA;IACA,gBAAA;EAKF;AACF","sourcesContent":["$breakpoint-xs: 480px;\n$breakpoint-sm: 768px;\n$breakpoint-md: 925px;\n$breakpoint-lg: 1366px;\n\n.super-pickem-user-dash-header{\n  width:100%;\n  margin: 0 auto;\n  display: flex;\n  justify-content: center;\n  padding:16px 5px;\n  align-items: center;\n  @media (max-width: $breakpoint-md) {\n    padding: 5px;\n  }\n}\n\n.super-pickem-user-dash-trophy{\n  width:48px;\n  @media (max-width: $breakpoint-md) {\n    width: 20px;\n    padding-right: 5px;\n  }\n}\n\n.bracket-box-header{\n  width: 100%;\n  background: #F2F2F2;\n  height:215px;\n  border-top: 8px solid #FFC60A;\n  border-bottom: 8px solid #FFC60A;\n  @media (max-width: $breakpoint-md) {\n    height:87px;\n    border-top: 4px solid #FFC60A;\n    border-bottom: 4px solid #FFC60A;\n  }\n}\n\n.super-pickem-user-dash-username {\n  font-weight: 800 !important;\n  margin-left: 8px !important;\n  @media (max-width: $breakpoint-md) {\n    color: #002129;\n    font-family: Inter;\n    font-size: 16px !important;\n    font-style: normal;\n    line-height: normal;\n    font-weight: 800 !important;\n    margin-left: 0px;\n  }\n}\n\n.super-pickem-user-dash-headings {\n  color: #4A4A4A;\n  text-align: center;\n  font-family: Inter;\n  font-style: normal;\n  font-weight: 800;\n  line-height: normal;\n  text-decoration-line: underline;\n  font-size: 24px !important;\n\n  @media (max-width: $breakpoint-md) {  // Uses variable for breakpoint\n    font-size: 10px !important;  // Smaller font size on smaller screens\n    font-weight: 800 !important;\n\n  }\n}\n\n.super-pickem-user-dash-values {\n  color: #4A4A4A;\n  text-align: center;\n  font-family: Inter;\n  font-style: normal;\n  font-weight: 800;\n  line-height: normal;\n  font-size: 32px !important;\n\n  @media (max-width: $breakpoint-md) {  // Uses variable for breakpoint\n    font-size: 12px !important;  // Smaller font size on smaller screens\n    font-weight: 800;\n\n  }\n}\n\n.super-pickem-user-dash-double-line-values {\n  color: #4A4A4A;\n  text-align: center;\n  font-family: Inter;\n  font-style: normal;\n  font-weight: 800;\n  line-height: normal;\n  font-size: 24px !important;\n\n  @media (max-width: $breakpoint-md) {  // Uses variable for breakpoint\n    font-size: 12px !important;  // Smaller font size on smaller screens\n    font-weight: 800;\n\n  }\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
